module.exports = __webpack_public_path__ + "img/icon5.f20db38d.png";